import { useTheme } from '@material-ui/core';
import { BaseEdge, EdgeProps, getSmoothStepPath } from 'reactflow';

export const PROTOTYPE_EDGE_ID = 'prototype_edge';

export function PrototypeEdge(props: EdgeProps<{ color?: string }>) {
  const {
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    data,
  } = props;

  const theme = useTheme();

  const edgeStyle = {
    stroke: data?.color || theme.palette.accentSecondary.main,
    strokeWidth: '1px',
  };

  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
    borderRadius: theme.spacing(4),
  });

  return <BaseEdge path={edgePath} {...props} style={edgeStyle} />;
}
